import React, { FC, ReactNode } from "react";

// UI
import { Flex, FlexProps } from "@UI/Components/Flex/Flex";
import { Box } from "@UI/Components/Box/Box";

export interface CardIconWrapperProps extends FlexProps {
  children: ReactNode;
}

export const CardIconWrapper: FC<CardIconWrapperProps> = ({
  children,
  ...props
}) => {
  return (
    <Flex
      background="gray.200"
      p="1"
      borderRadius="sm"
      h="6"
      w="9"
      justifyContent="center"
      alignItems="center"
      __css={{
        svg: {
          height: "100%",
          width: "100%",
          objectFit: "contain",
          display: "block",
          lineHeight: "1",
        },
      }}
      {...props}
    >
      <Box h="full" w="full">
        {children}
      </Box>
    </Flex>
  );
};
